import { Box, Typography, Grid, Paper, CircularProgress } from '@mui/material';
import React from 'react';
import QuizzeWidget from './QuizzeWidget';
import StoryWidget from './StoryWidget';
import VideoWidget from './VideoWidget';
import { useTranslation } from 'react-i18next';

export default function Statistics(props) {

    const {videosWatched} = props;

    const {t} = useTranslation()

    if (!props.stories ||!props.characterStories || !props.videos ||!props.subtopics) return <CircularProgress/>


    const renderStories = () => {

        const storiesJS = [];

        for (let story of props.stories) {
            const characterStory = props.characterStories.find(val => story.id === val.storyId);
            if (!characterStory) continue
            const choice = props.choices.find(value => 
                value.relevant && value.substoryId === story.id
            )
            let character = null
            if (characterStory) {
                character = props.characters.find(val => val.id === characterStory.characterId);
            }
            const progress = props.storyProgress.find(value => {
                return story.id === value.storyId
            });
            storiesJS.push(<StoryWidget progress={progress} story={story} charImg={character ? character.imgSrc : null} n_choices={choice.answers.length}/>)
        }
        return storiesJS;
    }

    const renderQuizze = () => {

        const quizzeJS = [];

        for (let quiz of props.subtopics) {
            const progress = props.quizProgress.find(value => {
                return quiz.id === value.subtopicId
            });
            quizzeJS.push(<QuizzeWidget progress={progress} quiz={quiz}/>)
        }
        return quizzeJS;
    }

    const renderVideos = () => {

        const videosJS = [];

        for (let video of props.videos) {
            const videoWatched = videosWatched.find(value => {
                return video.id === value
            })
            videosJS.push(<VideoWidget videoWatched={videoWatched} video={video}/>)
        }
        return videosJS;
    }

    return(
        <Box>
            <Box sx={{p: {xs: 1, sm: 2, md: 4}, m: {xs: 1, sm: 2, md: 4}}}> 
                <Box sx={{display: "flex", justifyContent: "center", mb: 3}}>
                    <Paper sx={{width: "fit-content", p: 2}}>
                        <Typography variant="h1">{t("progressTitle")}</Typography>
                    </Paper>
                </Box>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Grid container>
                        <Grid item xs={12} sm={6} lg={4} sx={{display: "flex", flexDirection: "column", mb: 2}}>
                            <Paper sx={{ml: 3, mr: 3, mb: 2}}>
                                <Typography variant="h2" sx={{mt: 2, mb: 2}}>{t("navigationCat3")}</Typography>
                            </Paper>
                            {renderStories()}
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4} sx={{display: "flex", flexDirection: "column", mb: 2}}>
                            <Box sx={{display: "flex", justifyContent: "center"}}>
                                <Paper sx={{ml: 3, mr: 3, mb: 2, width: "100%"}}>
                                    <Typography variant="h2" sx={{mt: 2, mb: 2}}>{t("navigationCat4")}</Typography>
                                </Paper>
                            </Box>
                            {renderQuizze()}
                        </Grid>
                        <Grid item xs={12} sm={6} lg={4} sx={{display: "flex", flexDirection: "column", mb: 2}}>
                            <Paper sx={{ml: 3, mr: 3, mb: 2}}>
                                <Typography variant="h2" sx={{mt: 2, mb: 2}}>{t("navigationCat2")}</Typography>
                            </Paper>
                            {renderVideos()}
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>

    )
}